import { Child } from '../interfaces/child.interface';
import { AuthService } from '../../core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

export let PanelControlChilds: Child[];

const pais: string = AuthService.prototype.getDataPais();

PanelControlChilds = [
    {
        'Childs': [],
        'ID': 9901,
        'Icon': null,
        'Name': 'StarAuto',
        'Rights': 1,
        'Template': null,
        'Title': 'labels.starauto',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/starauto'
    }, {
        'Childs': [],
        'ID': 9902,
        'Icon': null,
        'Name': 'Taller',
        'Rights': 1,
        'Template': null,
        'Title': 'labels.taller',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/taller'
    }, {
        'Childs': [], 'ID': 9903, 'Icon': null,
        'Name': 'Config. Impresiones', 'Rights': 1,
        'Template': null,
        'Title': 'labels.config_impresiones',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/impresiones'
    }, {
        'Childs': [], 'ID': 9904, 'Icon': null,
        'Name': 'Gestión de Usuario', 'Rights': 1,
        'Template': null,
        'Title': 'labels.ges_usuario',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/gestion-usuarios'
    }, {
        'Childs': [], 'ID': 9905, 'Icon': null,
        'Name': 'Notificaciones', 'Rights': 1,
        'Template': null,
        'Title': 'labels.notificaciones',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/notificaciones'
    }, {
        'Childs': [], 'ID': 9906, 'Icon': null,
        'Name': 'Gestión SMS', 'Rights': 1,
        'Template': null,
        'Title': 'labels.ges_SMS',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/gestion-sms'
    }, {
        'Childs': [], 'ID': 9907, 'Icon': null,
        'Name': 'Config. Roles', 'Rights': 1,
        'Template': null,
        'Title': 'panel-control.config-roles.title',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/roles'
    }, {
        'Childs': [], 'ID': 9908, 'Icon': null,
        'Name': 'Gestión EMail', 'Rights': 1,
        'Template': null,
        'Title': 'labels.ges_EMail',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/gestion-email'
    }, {
        'Childs': [], 'ID': 9909, 'Icon': null,
        'Name': 'Interfaces', 'Rights': 1,
        'Template': null,
        'Title': 'labels.interfaces',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/interfaces'
    }, {
        'Childs': [], 'ID': 9910, 'Icon': null,
        'Name': 'Gestión de Horarios', 'Rights': 1,
        'Template': null,
        'Title': 'labels.ges_horarios',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/horarios'
    }, {
        'Childs': [], 'ID': 9911, 'Icon': null,
        'Name': 'Certificado', 'Rights': 1,
        'Template': null,
        'Title': 'labels.certificado',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/certificado'
    }, {
        'Childs': [], 'ID': 9912, 'Icon': null,
        'Name': 'Contabilidad', 'Rights': 1,
        'Template': null,
        'Title': 'labels.contabilidad',
        'Type': 'home',
        'Url': null,
        'route': '/dms/panel-control/contabilidad'
    }

]

if (pais == 'fr' || pais == 'pt') {
    PanelControlChilds = PanelControlChilds.filter(e => e.ID !== 9912 && e.ID !== 9911);
}
